module.exports = {
	"header": "Spotin expands to Dhaka",
	"date": "2021/10/11",
	"imgSrc": "9.jpg",
	"imgAlt": "Spotin expands to Dhaka",
	"ingress": "By: it-Retail (in Swedish)",
	"externalLink": "https://it-retail.se/spotin-expanderar-till-dhaka/"
};


//////////////////
// WEBPACK FOOTER
// ./pages/media/9/article.json
// module id = 99
// module chunks = 0